module.exports = __webpack_public_path__ + "img/lv10.ef62aae4.png";